import {SET_SUMMARY, SET_WAIT_LIST_PICKUP_SITE,
    SET_SUBSCRIPTION_NEXT_DELIVERY_DATE, SET_ALLOW_ORDER_EDIT, SET_PICKUP_SITE,
    SET_PICKUP_SITES_DELIVERY_DATE, SET_WEB_ORDER, SET_PAYMENT_PLAN,
    SET_PAYMENT_METHOD, SET_CAN_SAVE_DELIVERY_HOLD, SET_CUSTOM_AMOUNT,
    SET_PAYMENT_TYPE, SET_ALLOW_CONTINUE_PAYMENT, SET_VACATIONS, SET_REQUIRED_MAKE_UP_DATA,
    SET_CREATEING_SUBSCRIPTION, SET_MULTI_ORDER_EDIT, SET_ON_PERMANENT_HOLD} from '../actionTypes';
import {PaymentMethod, PaymentPlansSinglePayment, PaymentPlansAutoPayment,
    PaymentMethodsSinglePayment, PaymentMethodsAutoPayment, PaymentPlans,
    JoinSteps, URLs, JoinModes, FetchingTypes, SubscriptionHoldReason} from '../../common/constants';
import {ajax, redirectPage, getUrlParams} from "../../common/utils";
import {setDirty} from "./commonActions";
import {clearSharesSelection, getSignupData, gotoStep} from "../join/joinActions";
import {fetchingData, dataFetched, errorFetching, isFetching} from "./fetchingActions";

export function subscriptionSummaryParser(json, staticData) {
    let subscriptionSummary = json.subscriptionSummary;
    let store = json.store;
    if (subscriptionSummary) {
        if (subscriptionSummary.shareItems) {
            for (let i = 0; i < subscriptionSummary.shareItems.length; i++) {
                subscriptionSummary.shareItems[i].quantity = subscriptionSummary.shareItemQuantities[i];
                subscriptionSummary.shareItems[i].selectedSchedule = subscriptionSummary.shareSchedules[i];
            }
        }
        if (subscriptionSummary.waitListItems) {
            for (let i = 0; i < subscriptionSummary.waitListItems.length; i++) {
                subscriptionSummary.waitListItems[i].quantity = subscriptionSummary.waitListItemQuantities[i];
                subscriptionSummary.waitListItems[i].waitList = true;
            }
        }
        let summary = subscriptionSummary;
        let shareItems = [];
        for(let key in subscriptionSummary.shareSchedules) {
            if(subscriptionSummary.shareSchedules.hasOwnProperty(key)) {
                let schedule = subscriptionSummary.schedules[subscriptionSummary.shareSchedules[key]];
                if (!schedule || schedule === null) {
                    const error = {
                        key: key,
                        shareSchedules: subscriptionSummary.shareSchedules,
                        schedules: subscriptionSummary.schedules
                    };
                    Raven.captureMessage("Schedule is undefined in subscription summary", {extra: error});
                } else if (schedule.dates.includes(subscriptionSummary.nextDeliveryDate)) {
                    shareItems.push(subscriptionSummary.shareItems[key]);
                }
            }
        }
        let allSharesWithZeroPrice = shareItems
            && !shareItems.some(shareItem=>shareItem.price > 0);
        summary.nextDeliveryDate = !store || !store.deliveryDate?subscriptionSummary.nextDeliveryDateActual:store.deliveryDate;
        if (allSharesWithZeroPrice) {
            summary.extraCost = (subscriptionSummary.pickupSite||{}).extraCost;
            summary.extraCostType = (subscriptionSummary.pickupSite||{}).extraCostType;
        }
        summary.canEditExistingOrder =
            (staticData.storePaymentMethods && staticData.storePaymentMethods[0] === PaymentMethod.BALANCE.key) ||
            (staticData.isChargeOnDelivery);
        if(subscriptionSummary.makePaymentPaymentPlans) {
            subscriptionSummary.makePaymentPaymentPlans = calcPaymentPlansPrice(subscriptionSummary.makePaymentPaymentPlans,
                subscriptionSummary.shareItems, subscriptionSummary.pickupSite, subscriptionSummary.discount);
            const filteredPaymentPlans = filterPaymentPlans(subscriptionSummary.makePaymentPaymentPlans, subscriptionSummary.balance);
            summary.singlePaymentPlans = filteredPaymentPlans.singlePaymentPlans;
            summary.autoPaymentPlans = filteredPaymentPlans.autoPaymentPlans;
        }
        if(subscriptionSummary.paymentMethod !== PaymentMethod.NONE.key) {
            summary.paymentMethodToken = subscriptionSummary.paymentMethod;
        }
        summary.paymentMethod = PaymentMethod.NONE.key;
        if(subscriptionSummary.makePaymentPaymentMethods) {
            const filteredPaymentMethods = filterPaymentMethods(subscriptionSummary.makePaymentPaymentMethods);
            summary.singlePaymentMethods = filteredPaymentMethods.singlePaymentMethods;
            summary.autoPaymentMethods = filteredPaymentMethods.autoPaymentMethods;
        }
        summary.hasToken =  summary.hasPreapproval && summary.paymentMethodToken !== PaymentMethod.NONE.key;
        summary.paymentPlan = subscriptionSummary.paymentPlan;
        // summary.paymentType = summary.singlePaymentMethods && summary.singlePaymentMethods.length > 0 && !isEmptyObj(summary.singlePaymentPlans)?
        //     PaymentTypes.SINGLE_PAYMENT.type:PaymentTypes.AUTO_PAYMENT.type; //Fix for FS-515
        summary.seasons.sort(function (season, season1) {
            return season.endDateStr < season1.endDateStr;
        });
        summary.isSetOnPermanentHold = summary.holdReason === SubscriptionHoldReason.ADMIN;
        summary.origPickupSite = summary.pickupSite ? {key: summary.pickupSite.key, deliveryDays: summary.pickupSite.deliveryDays} : {};
        return summary;
    }
    return {
        nextDeliveryDate: null,
        extraCost: null,
        extraCostType: null,
        credits: null,
        hasPreapproval: null,
        subscriptionKey: null
    };
}

export function setSummary(summary) {
    return {
        type: SET_SUMMARY,
        summary
    }
}

export function setPaymentType(paymentType) {
    return {
        type: SET_PAYMENT_TYPE,
        paymentType
    }
}

export function setPaymentPlan(paymentPlan, paymentType) {
    return {
        type: SET_PAYMENT_PLAN,
        paymentPlan,
        paymentType
    }

}

export function setPaymentMethod(paymentMethod, paymentType) {
    return {
        type: SET_PAYMENT_METHOD,
        paymentMethod,
        paymentType
    }

}

export function setPickupSite(pickupSite) {
    return function (dispatch, getState) {
        const currentPickupSite = (getState().summary || {}).pickupSite;
        //Clear selection if pickup site changed
        if (currentPickupSite) {
            dispatch(clearSharesSelection());
        }
        dispatch(function (pickupSite) {
            return {
                type: SET_PICKUP_SITE,
                pickupSite
            };
        }(pickupSite))
    }
}

export function setWaitListPickupSite(waitListSite) {
    return {
        type: SET_WAIT_LIST_PICKUP_SITE,
        waitListSite
    };
}
export function setPickupSitesAndDeliveryDate(nextDeliveryDate, pickupSite, waitListSite) {
    return {
        type: SET_PICKUP_SITES_DELIVERY_DATE,
        nextDeliveryDate,
        pickupSite,
        waitListSite
    };
}

export function setPickupSitesAndDeliveryDateActual(pickupSite, nextDeliveryDate) {
    return function (dispatch) {
        dispatch(setPickupSite(pickupSite));
        dispatch(setNextDeliveryDate(nextDeliveryDate));
    };
    // return {
    //     type: SET_PICKUP_SITES_DELIVERY_DATE_ACTUAL,
    //     pickupSite,
    //     nextDeliveryDate
    // };
}

export function setNextDeliveryDate(nextDeliveryDate) {
    return {
        type: SET_SUBSCRIPTION_NEXT_DELIVERY_DATE,
        nextDeliveryDate
    };
}

export function setAllowOrderEditToStore(flag){
    return {
        type: SET_ALLOW_ORDER_EDIT,
        allowOrderEdit: flag
    }
}

export function setEditMultiOrder(flag){
    return {
        type: SET_MULTI_ORDER_EDIT,
        editMultiOrder: flag
    }
}

function calcPaymentPlansPrice(paymentPlans, shareItems, pickupSite, discount){
    let totalPrice = 0;
    if (shareItems)
        shareItems.map(item => {
           totalPrice += item.price * item.quantity;
        });
    if (pickupSite && pickupSite.extraCost > 0)
        if (pickupSite.extraCostType === 'Fixed')
            totalPrice += pickupSite.extraCost;
        else
            totalPrice += totalPrice * (pickupSite.extraCost / 100);

    if (discount)
        totalPrice -= totalPrice * (discount / 100);

    paymentPlans.map(plan => {
       if (plan.type === PaymentPlans.DynamicPrePayment){
           plan.totalToPay = plan.amount * totalPrice
       }
    });
    return paymentPlans;
}

function filterPaymentPlans(paymentPlans, balance) {
    if(!paymentPlans) {
        return [];
    }
    return {
        singlePaymentPlans: paymentPlans.filter(function (paymentPlan) {
            if (paymentPlan.isPayMyDebit && balance > -0.01) {
                return false;
            }
            return PaymentPlansSinglePayment.includes(paymentPlan.type);
        }),
        autoPaymentPlans: paymentPlans.filter(function (paymentPlan) {
            return PaymentPlansAutoPayment.includes(paymentPlan.type);
        })
    }
}

function filterPaymentMethods(paymentMethods) {
    if(!paymentMethods) {
        return [];
    }
    return {
        singlePaymentMethods: paymentMethods.filter(function (paymentMethod) {
            return PaymentMethodsSinglePayment.includes(paymentMethod);
        }),
        autoPaymentMethods: paymentMethods.filter(function (paymentMethod) {
            return PaymentMethodsAutoPayment.includes(paymentMethod);
        })
    }
}
export function setCanSaveDeliveryHold(canSaveDeliveryHold) {
    return {
        type: SET_CAN_SAVE_DELIVERY_HOLD,
        canSaveDeliveryHold
    }
}
export function createWaitListSubscription(memberKey, waitListItems){
    return function(dispatch, getState){
        const fetchUrl = '/dispatcher/SignupService.createWaitListSubscription';
        const data = {
            farmKey: getState().staticData.farmKey,
            seasonKey: getState().staticData.seasonKey,
            memberKey: memberKey,
            waitListItems: JSON.stringify(waitListItems)
        };
        dispatch(fetchingData(FetchingTypes.CREATE_SUBSCRIPTION));
        return ajax(fetchUrl, data)
            .then(() => {
                dispatch(gotoStep(JoinSteps.THANK_YOU));
                dispatch(setDirty(false));
                dispatch(dataFetched());
            }).catch(error => dispatch(errorFetching(error)));
    }
}

export function createGuestSubscription(memberKey, pickupSiteKey){
    return function(dispatch, getState){
        const state = getState();
        const fetchUrl = '/dispatcher/SignupService.createGuestSubscription';
        const data = {
            farmKey: state.staticData.farmKey,
            seasonKey: getState().staticData.seasonKey,
            memberKey: memberKey,
            pickupSiteKey: pickupSiteKey
        };
        dispatch(fetchingData(FetchingTypes.CREATE_SUBSCRIPTION));
        return ajax(fetchUrl, data)
            .then(response => handleCreateGuestSubscriptionResponse(response, state.staticData))
            .then(dispatch(dataFetched()))
            .catch(error => {
                dispatch(errorFetching(error));
            })
    }
}

function handleCreateGuestSubscriptionResponse(response, staticData) {
    if (response.statusCode === "OK") {
        window.location.assign(redirectPage(URLs.STORE, staticData));
    }
}

export function getAddSubscriptionData(subscriptionKey) {
    return function(dispatch, getState){
        const state = getState();
        dispatch(fetchingData(FetchingTypes.LOAD_SIGNUP_DATA));
        if(!state.memberDetails.key) {
            window.location.assign(redirectPage(URLs.ACCOUNT, state.staticData));
            return;
        }
        const fetchUrl = '/dispatcher/WebStoreService.getSubscriptionSummary';
        const data = {
            farmKey: state.staticData.farmKey,
            seasonKey: state.staticData.seasonKey,
            memberKey: state.memberDetails.key,
            subscriptionKey
        };
        return ajax(fetchUrl, data)
            .then(json => parseSummaryData(json))
            .then(summary => {
                dispatch(setSummary(summary));
                dispatch(getSignupData(JoinModes.ADD));
                dispatch(dataFetched());
            })
            .catch(error => {
                dispatch(errorFetching(error, {action: getAddSubscriptionData, args:[subscriptionKey]}));
            })
    }
}

function parseSummaryData(summary){
    if (summary.shareItems) {
        for (let i = 0; i < summary.shareItems.length; i++) {
            summary.shareItems[i].quantity = summary.shareItemQuantities[i];
            summary.shareItems[i].selectedSchedule = summary.shareSchedules[i];
        }
    }
    if (summary.waitListItems) {
        for (let i = 0; i < summary.waitListItems.length; i++) {
            summary.waitListItems[i].quantity = summary.waitListItemQuantities[i];
            summary.waitListItems[i].waitList = true;
        }
    }
    return summary;
}

export function setCustomAmount(customAmount) {
    return {
        type: SET_CUSTOM_AMOUNT,
        customAmount
    }
}
export function setAllowContinuePayment(allowContinuePayment) {
    return {
        type: SET_ALLOW_CONTINUE_PAYMENT,
        allowContinuePayment
    }
}

export function setVacations(vacationStart, vacationEnd) {
    return {
        type: SET_VACATIONS,
        vacationStart,
        vacationEnd
    }
}

export function setRequiredMakeUpData(requiredMakeUpSchedules, requiredMakeUpSchedulesCount, requiredMakeUpSchedulesDates) {
    let requiredMakeUpData = [];
    if (requiredMakeUpSchedules) {
        for (let i = 0; i < requiredMakeUpSchedules.length; i++) {
            for (let j = 0; j < requiredMakeUpSchedulesCount[i]; j++) {
                requiredMakeUpData.push({schedule: requiredMakeUpSchedules[i], dates: requiredMakeUpSchedulesDates[i].sort()});
            }
        }
    } else {
        requiredMakeUpData = undefined;
    }
    return {
        type: SET_REQUIRED_MAKE_UP_DATA,
        requiredMakeUpData
    }
}

export function setWebOrder(webOrderKey) {
    return {
        type: SET_WEB_ORDER,
        webOrderKey
    }
}
export function isCreatingSubscription(isCreatingSubscription) {
    return {
        type: SET_CREATEING_SUBSCRIPTION,
        isCreatingSubscription
    }
}
export function isAddSubscription() {
    const params = getUrlParams();
    if (params.mode === 'add') {
        const subscriptionKey = params.s;
        if (subscriptionKey)
            return true;
    }
    return false;
}

export function setOnPermanentHold(isSetOnPermanentHold) {
    return {
        type: SET_ON_PERMANENT_HOLD,
        isSetOnPermanentHold
    }
}

export function setSubscriptionOnPermanentHold() {
    return function(dispatch, getState) {
        const state = getState();
        const fetchUrl = '/dispatcher/WebStoreService.setSubscriptionOnPermanentHold';
        const data = {
            farmKey: state.staticData.farmKey,
            memberKey: state.memberDetails.key,
            subscriptionKey: state.summary.key,
            isOnPermanentHold: state.summary.isSetOnPermanentHold
        };
        dispatch(fetchingData(FetchingTypes.UPDATE_VACATION));
        return ajax(fetchUrl, data)
            .then(() => {
                window.location.reload(true);
            })
            .catch(error => {
                dispatch(errorFetching(error));
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/common/subscriptionSummaryActions.js